<template>
  <v-app v-if="$auth.inProgress === 'none' && !permissionLoading" class="industrial-app">
    <AppBar @drawerChange="drawer = !drawer" @alarmDrawerChange="alarmDrawer = !alarmDrawer"></AppBar>
    <Navigation :drawer.sync="drawer"></Navigation>
    <AlarmNavigation :drawer.sync="alarmDrawer"></AlarmNavigation>
    <v-main class="industrial-main">
      <router-view/>
    </v-main>
    <v-overlay :value="contextLoading" z-index="9998" color="rgba(28, 31, 38, 0.7)">
      <v-row align="center" justify="center">
        <v-col cols="auto" class="text-center">
          <v-progress-linear indeterminate color="primary" height="3" class="mb-4" style="width: 200px;" />
          <div class="text-body-2 white--text">กำลังโหลดข้อมูล...</div>
        </v-col>
      </v-row>
    </v-overlay>
  </v-app>
  <ProgressIndicator v-else />
</template>

<script>

import ProgressIndicator from '@/components/ProgressIndicator'
import AppBar from '@/components/layout/AppBar'
import Navigation from '@/components/layout/Navigation'
import AlarmNavigation from '@/components/layout/AlarmNavigation'
export default {
  name: 'App',
  components: {
    AppBar,
    Navigation,
    ProgressIndicator,
    AlarmNavigation
  },
  data: () => ({
    drawer: false,
    alarmDrawer: false,
    group:null
  }),
  computed: {
    permissionLoading () {
      return this.$store.state.User.permissionLoading
    },
    contextLoading () {
      return this.$store.state.User.contextLoading
    }
  },
};
</script>

<style>
.industrial-app {
  background: var(--surface-base, #F4F5F7);
}

.industrial-main {
  background: var(--surface-base, #F4F5F7) !important;
}

.industrial-panel,
.v-card.industrial-panel {
  background: var(--surface-panel, #fff);
  border: var(--panel-border, 1px solid #D1D5DB);
  border-radius: var(--radius-panel, 4px) !important;
  box-shadow: var(--panel-shadow, 0 1px 3px rgba(0, 0, 0, 0.06));
}

.mono-value {
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums;
}

.overline-label {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-muted, #6B7280);
}
</style>
